<template>
  <div>
    <header-folder-buttons
      v-if="showHeaderFolderButtons"
      :user-id="userObject.userId"
      :group-id="groupId"
      :is-sys-admin="userObject.isSysAdmin"
    />
    <header-action-project-buttons
      v-if="showHeaderActionProjectButtons && privilegesForItem"
      :is-sys-admin="userObject.isSysAdmin"
      :privileges-for-item="privilegesForItem"
    />
    <header-action-page-buttons
      v-if="showHeaderActionPageButtons && privilegesForItem"
      :is-sys-admin="userObject.isSysAdmin"
      :privileges-for-item="privilegesForItem"
      :render-sidebar-in-parent="effectiveRenderSidebarInParent"
    />
    <header-action-save-buttons v-if="showHeaderActionSaveButtons"/>
    <!-- <header-action-back-button
      v-if="showHeaderBackButtons"
      :user-object="userObject"
      :group-id="groupId"
      :pageType="currentPageType"
    /> -->
  </div>
</template>

<script>
import GetGroupSettings from '@/graphQlQueries/queries/getGroupSettings';

export default {
  name: 'HeaderActionButtons',
  components: {
    HeaderActionPageButtons: () => import('@/components/header/Buttons/HeaderActionPageButtons.vue'),
    // HeaderActionBackButton: () => import('@/components/header/Buttons/HeaderActionBackButton.vue'),
    HeaderActionProjectButtons: () => import('@/components/header/Buttons/HeaderActionProjectButtons.vue'),
    HeaderActionSaveButtons: () => import('@/components/header/Buttons/HeaderActionSaveButtons.vue'),
    HeaderFolderButtons: () => import('@/components/header/Buttons/HeaderFolderButtons.vue'),
  },
  data: () => ({
    groupSettings: null,
    // Effective value announced by the open KEditor; null = no editor open.
    editorSidebarInParent: null,
  }),
  mounted() {
    this.$root.$on('keditor-sidebar-in-parent', this.setEditorSidebarInParent);
    // KEditor may have mounted first and announced already: ask again.
    this.$root.$emit('keditor-theme-frage');
  },
  beforeDestroy() {
    this.$root.$off('keditor-sidebar-in-parent', this.setEditorSidebarInParent);
  },
  methods: {
    setEditorSidebarInParent(on) {
      this.editorSidebarInParent = on;
    },
  },
  apollo: {
    groupSettings: {
      query: GetGroupSettings,
      variables() {
        return {
          groupId: this.groupId,
        };
      },
      update(data) {
        return data.groups_by_pk?.settings || {};
      },
      skip() {
        return !this.groupId;
      },
      fetchPolicy: 'network-only',
    },
  },
  computed: {
    showHeaderActionSaveButtons() {
      return this.currentPageType === 'folder-settings'
        || this.currentPageType === 'project-settings'
        || this.currentPageType === 'general-settings'
        || this.currentPageType === 'page-settings';
    },
    showHeaderActionProjectButtons() {
      return this.currentPageType === 'project';
    },
    showHeaderActionPageButtons() {
      return this.currentPageType === 'page';
    },
    showHeaderFolderButtons() {
      return this.currentPageType === 'folder';
    },
    effectiveRenderSidebarInParent() {
      // The open editor knows best (its project's editor_version); else the group value.
      if (this.editorSidebarInParent !== null) return this.editorSidebarInParent;
      if (this.groupSettings && this.groupSettings.enable_vue3_editor !== undefined) {
        return !!this.groupSettings.enable_vue3_editor;
      }
      return !!this.renderSidebarInParent;
    },
    showHeaderBackButtons() {
      return !!this.$route.params.parametersOfUrl
        || this.currentPageType === 'general-settings'
        || this.$route.path === '/folder-settings';
    },
  },
  props: {
    userObject: {
      type: Object,
    },
    groupId: {
      type: Number,
    },
    privilegesForItem: {
      type: Array,
    },
    currentPageType: {
      type: String,
    },
    renderSidebarInParent: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
